exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-articles-talks-js": () => import("./../../../src/pages/articles-talks.js" /* webpackChunkName: "component---src-pages-articles-talks-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-relevant-experience-js": () => import("./../../../src/pages/relevant-experience.js" /* webpackChunkName: "component---src-pages-relevant-experience-js" */),
  "component---src-pages-showcase-js": () => import("./../../../src/pages/showcase.js" /* webpackChunkName: "component---src-pages-showcase-js" */)
}

